let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lln6F")).then(() => parcelRequire('i6sCI'));